import React, { createContext, useCallback, useContext, useEffect, useMemo, useRef } from 'react';
import useWebSocket from 'react-use-websocket';

const WebSocketContext = createContext();

export const useWebSocketContext = () => useContext(WebSocketContext);

export const WebSocketProvider = ({ children }) => {
  const hasJWT = () => !!localStorage.getItem('token');
  const getSocketUrl = useCallback(() => {
    const token = localStorage.getItem('token');
    if (!token || !process.env.REACT_APP_CHAT_WS_URL) return null;

    return `${process.env.REACT_APP_CHAT_WS_URL}/v1/connect?token=${encodeURIComponent(token)}`;
  }, []);

  const socket = useWebSocket(getSocketUrl, {
    shouldReconnect: () => hasJWT(),
    reconnectInterval: 3000,
    reconnectAttempts: 20,
    retryOnError: true,
  }, hasJWT());

  const sendJsonMessageRef = useRef(socket.sendJsonMessage);

  useEffect(() => {
    sendJsonMessageRef.current = socket.sendJsonMessage;
  }, [socket.sendJsonMessage]);

  const sendJsonMessage = useCallback(
    (message) => sendJsonMessageRef.current(message, false),
    []
  );

  const value = useMemo(
    () => ({
      ...socket,
      sendJsonMessage,
    }),
    [socket, sendJsonMessage]
  );

  return (
    <WebSocketContext.Provider value={value}>
      {children}
    </WebSocketContext.Provider>
  );
};
